require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./truncatedtext"), require("./container"), require("./label"), require("./context"), require("./list"), require("./progressindicator"), require("./link"), require("./toolbar"), require("./menu"), require("./contextmenu"), require("./itemdnd"), require("./textinput"), require("./breadcrumb"), require("./tile"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./flexlayout", "./truncatedtext", "./container", "./label", "./context", "./list", "./progressindicator", "./link", "./toolbar", "./menu", "./contextmenu", "./itemdnd", "./textinput", "./breadcrumb", "./tile"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./truncatedtext"), require("./container"), require("./label"), require("./context"), require("./list"), require("./progressindicator"), require("./link"), require("./toolbar"), require("./menu"), require("./contextmenu"), require("./itemdnd"), require("./textinput"), require("./breadcrumb"), require("./tile")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./flexlayout"], root["./truncatedtext"], root["./container"], root["./label"], root["./context"], root["./list"], root["./progressindicator"], root["./link"], root["./toolbar"], root["./menu"], root["./contextmenu"], root["./itemdnd"], root["./textinput"], root["./breadcrumb"], root["./tile"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__24__, __WEBPACK_EXTERNAL_MODULE__25__, __WEBPACK_EXTERNAL_MODULE__27__, __WEBPACK_EXTERNAL_MODULE__29__, __WEBPACK_EXTERNAL_MODULE__31__, __WEBPACK_EXTERNAL_MODULE__38__, __WEBPACK_EXTERNAL_MODULE__40__, __WEBPACK_EXTERNAL_MODULE__46__, __WEBPACK_EXTERNAL_MODULE__47__, __WEBPACK_EXTERNAL_MODULE__71__, __WEBPACK_EXTERNAL_MODULE__74__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[39],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _NavigatorResources = _interopRequireDefault(__webpack_require__(355));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_NavigatorResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.toIndexMap = toIndexMap;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _label = _interopRequireDefault(__webpack_require__(19));

var _progressindicator = _interopRequireDefault(__webpack_require__(27));

var _menu = _interopRequireDefault(__webpack_require__(38));

var _contextmenu = _interopRequireDefault(__webpack_require__(40));

var _list = _interopRequireWildcard(__webpack_require__(25));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _DataView = _interopRequireDefault(__webpack_require__(110));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var dataViewClassName = _DataView["default"].dataView.replace(/"/g, '');

var groupBy = _utils.lodash.groupBy,
    findIndex = _utils.lodash.findIndex,
    toPairs = _utils.lodash.toPairs;
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

function toIndexMap(prevData, newData) {
  var map = {};
  newData.forEach(function (m, index) {
    map[index] = findIndex(prevData, function (_ref) {
      var id = _ref.id;
      return id === newData[index].id;
    });
  });
  return map;
}

var DataView = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(DataView, _Component);

  function DataView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemRenderer", function (index, props) {
      var Item = _react["default"].cloneElement(_this.props.dataViewRenderer(index, props), {// extra props...
      });

      return Item;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderEmptyState", function () {
      var emptyState = _this.props.emptyState;
      var icon = emptyState.icon,
          label = emptyState.label;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-tid": "ba-data-view__empty-state",
        className: dataViewClassName + "__empty-state"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: dataViewClassName + "__empty-state-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: dataViewClassName + "__empty-state-icon"
      }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        iconId: icon.id,
        size: "xlarge"
      })), /*#__PURE__*/_react["default"].createElement("label", null, label)));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "zip", function (inputEntries, zipBy) {
      var output = {};
      inputEntries.forEach(function (entry) {
        var label = entry[0],
            data = entry[1];
        var newValue;
        var newLabel = zipBy(label);

        if (!output[newLabel]) {
          newValue = [].concat(data);
        } else {
          newValue = [].concat(output[newLabel], data);
        }

        output[newLabel] = newValue;
      });
      return toPairs(output);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSelectionChange", function (event) {
      var _this$props = _this.props,
          onSelectionChange = _this$props.onSelectionChange,
          grouped = _this$props.grouped,
          selectionMode = _this$props.selectionMode,
          data = _this$props.data,
          selectedItems = _this$props.selectedItems,
          toSelectionMap = _this$props.toSelectionMap;
      var isSingleMode = selectionMode === 'single';
      var selectedItem;

      if (isSingleMode) {
        selectedItem = _utils.listHelper.singleSelect(event, grouped ? _this.groupedData : data, selectedItems, _this._getId);

        if (toSelectionMap && selectedItem != null) {
          var _this$_toObjectMap;

          selectedItem = _this._toObjectMap((_this$_toObjectMap = {}, _this$_toObjectMap[selectedItem] = true, _this$_toObjectMap));
        }
      } else {
        selectedItem = _utils.listHelper.multiSelect(event, grouped ? _this.groupedData : data, selectedItems, _this._getId).selectedMap;
      }

      _this.setState({
        selectedItem: selectedItem
      }, function () {
        onSelectionChange(selectedItem);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getId", function (index) {
      return _this.props.getId ? _this.props.getId(_this.props.grouped ? _this.groupedData[index] : _this.props.data[index], index) : index;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isSelected", function (index) {
      var id = _this._getId(index);

      var _this$props2 = _this.props,
          selectionMode = _this$props2.selectionMode,
          selectedItems = _this$props2.selectedItems,
          toSelectionMap = _this$props2.toSelectionMap;

      if (toSelectionMap) {
        return !!selectedItems[id];
      }

      var isSingleMode = selectionMode === 'single';

      if (isSingleMode) {
        return selectedItems === id;
      }

      return !!selectedItems[id];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getMoreData", function () {
      var _this$props3 = _this.props,
          getMoreData = _this$props3.getMoreData,
          data = _this$props3.data;
      getMoreData([].concat(data).pop());
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMenuChange", function (name, value) {
      var onItemMenu = _this.props.onItemMenu;
      onItemMenu(_this.state.menuTarget, value);

      _this.setState({
        showMenu: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onActiveChange", function (_ref2) {
      var index = _ref2.index;
      var _this$props4 = _this.props,
          onActiveChange = _this$props4.onActiveChange,
          data = _this$props4.data,
          grouped = _this$props4.grouped;
      var activeItem = grouped ? _this.groupedData[index] : data[index];
      onActiveChange && onActiveChange(activeItem);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderList", function () {
      var _this$props5 = _this.props,
          loaded = _this$props5.loaded,
          data = _this$props5.data,
          onItemMenu = _this$props5.onItemMenu,
          onMenuClick = _this$props5.onMenuClick,
          selectedItems = _this$props5.selectedItems,
          selectionMode = _this$props5.selectionMode,
          grouped = _this$props5.grouped,
          itemsRenderer = _this$props5.itemsRenderer,
          _groupBy = _this$props5.groupBy,
          tileView = _this$props5.tileView,
          others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props5, ["loaded", "data", "onItemMenu", "onMenuClick", "selectedItems", "selectionMode", "grouped", "itemsRenderer", "groupBy", "tileView"]);
      var listPassthroughProps = getInheritedProps(others, _list["default"]);
      var dataLength;
      var dataItemRenderer;

      if (grouped && data.length > 0) {
        _this.groupedData = [];
        var groupedDataObj;

        if (!_groupBy) {
          groupedDataObj = toPairs(groupBy(data, 'type'));
        } else {
          groupedDataObj = _groupBy(function (type) {
            return toPairs(groupBy(data, type));
          }, _this.zip);
        }

        var groupedDataEntries = groupedDataObj;
        groupedDataEntries.forEach(function (entry) {
          var label = entry[0],
              dataArr = entry[1];

          _this.groupedData.push({
            gpLabel: label
          });

          _this.groupedData = [].concat(_this.groupedData, dataArr);
        });
        var indexMap = toIndexMap(data, _this.groupedData);
        dataLength = _this.groupedData.length;

        dataItemRenderer = function dataItemRenderer(index, props) {
          var currItem = _this.groupedData[index];

          if (currItem.gpLabel) {
            return /*#__PURE__*/_react["default"].createElement(_list.ListItem, (0, _extends2["default"])({}, props, {
              active: false,
              selected: false,
              onMenu: null,
              outerClassName: (0, _utils.classnames)('groupedLabel')
            }), /*#__PURE__*/_react["default"].createElement(_label["default"], {
              key: "label-" + index,
              label: currItem.gpLabel,
              type: "caption",
              className: dataViewClassName + "__groupedLabel"
            }));
          }

          return _this._itemRenderer(indexMap[index], props);
        };
      } else {
        dataLength = data.length;
        dataItemRenderer = _this._itemRenderer;
      }

      var onMenuProps = {};

      if (onItemMenu) {
        onMenuProps.onMenu = function (x, y, e) {
          _this.setState({
            showMenu: true,
            clickTarget: e.target,
            menuTarget: _this.state.selectedItem
          });
        };
      } else if (onMenuClick) {
        onMenuProps.onMenu = function (x, y, e) {
          onMenuClick(x, y, e);
        };
      }

      if (loaded) {
        var classNames = (0, _utils.classnames)({
          multiSelecting: selectionMode !== 'single' && Object.keys(selectedItems).length > 1,
          tileView: tileView
        });
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_list["default"], (0, _extends2["default"])({
          "data-tid": "ba-common-data-view__list",
          className: classNames
        }, sanitize(others, DataView), listPassthroughProps, {
          listType: "simple",
          length: dataLength,
          itemRenderer: dataItemRenderer,
          itemsRenderer: itemsRenderer,
          onSelectionChange: _this._onSelectionChange,
          onActiveChange: _this._onActiveChange,
          getMoreData: _this._getMoreData,
          isSelected: _this._isSelected,
          selectionMode: selectionMode,
          onWheel: _this.props.onWheel
        }, onMenuProps)), data.length === 0 && _this._renderEmptyState());
      }

      return null;
    });
    return _this;
  }

  var _proto = DataView.prototype;

  _proto._toObjectMap = function _toObjectMap(boolMap) {
    var _this2 = this;

    var data = this.props.grouped ? this.groupedData : this.props.data;
    return Object.keys(boolMap).reduce(function (map, id) {
      if (boolMap[id]) {
        var item = data.find(function (obj, i) {
          return String(_this2._getId(i)) === id;
        });

        if (item) {
          map[id] = item;
        }
      }

      return map;
    }, {});
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props6 = this.props,
        loaded = _this$props6.loaded,
        itemMenuContent = _this$props6.itemMenuContent;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: dataViewClassName
    }, !loaded && /*#__PURE__*/_react["default"].createElement("div", {
      "data-tid": "ba-dataview__loader",
      className: dataViewClassName + "__loading"
    }, /*#__PURE__*/_react["default"].createElement(_progressindicator["default"], {
      size: "large",
      variant: "circle"
    })), this._renderList(), this.state.showMenu && /*#__PURE__*/_react["default"].createElement(_contextmenu["default"], {
      theme: true,
      placement: "bottomRight",
      triggerNode: this.state.clickTarget,
      domNodeToAttachTo: document.body,
      onChange: this._onMenuChange,
      onClose: function onClose() {
        return _this3.setState({
          showMenu: false
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null, /*#__PURE__*/_react["default"].createElement(_menu["default"].List, {
      content: itemMenuContent,
      name: "itemMenu"
    }))));
  };

  return DataView;
}(_react.Component);

exports["default"] = DataView;
(0, _defineProperty2["default"])(DataView, "propTypes", (0, _extends2["default"])({}, sanitize(_list["default"].propTypes, null, 'length', 'itemRenderer'), {
  data: _propTypes["default"].array.isRequired,
  itemMenuContent: _propTypes["default"].array,
  loaded: _propTypes["default"].bool,
  grouped: _propTypes["default"].bool,
  scrollToHideDataViewHeader: _propTypes["default"].bool,
  toSelectionMap: _propTypes["default"].bool,
  selectedItems: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].number]).isRequired,
  onSelectionChange: _propTypes["default"].func,
  onItemMenu: _propTypes["default"].func,
  onMenuClick: _propTypes["default"].func,
  dataViewRenderer: _propTypes["default"].func,
  itemsRenderer: _propTypes["default"].func,
  getMoreData: _propTypes["default"].func,
  onActiveChange: _propTypes["default"].func,
  groupBy: _propTypes["default"].func,
  getId: _propTypes["default"].func,
  tileView: _propTypes["default"].bool,
  onWheel: _propTypes["default"].func,
  emptyState: _propTypes["default"].shape({
    icon: _propTypes["default"].object,
    label: _propTypes["default"].string
  }),
  selectionMode: _propTypes["default"].oneOf(['none', 'disabled', 'single', 'multi'])
}));
(0, _defineProperty2["default"])(DataView, "defaultProps", {
  tileView: false,
  data: [],
  onSelectionChange: function onSelectionChange() {},
  getMoreData: function getMoreData() {},
  onWheel: function onWheel() {}
});

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(356);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.ContextDataViewItem = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _context = __webpack_require__(24);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _list = __webpack_require__(25);

var _itemdnd = _interopRequireDefault(__webpack_require__(46));

var _flexlayout = _interopRequireWildcard(__webpack_require__(16));

var _tile = _interopRequireDefault(__webpack_require__(74));

var _container = _interopRequireDefault(__webpack_require__(18));

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _InputView = _interopRequireDefault(__webpack_require__(357));

var _DataView = _interopRequireDefault(__webpack_require__(110));

var _dataViewItem = _interopRequireDefault(__webpack_require__(358));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var dataViewClassName = _DataView["default"].dataView.replace(/"/g, '');

var dataViewItemClassName = _dataViewItem["default"].dataViewItem.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes,
    sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

function createIcon(icon, locationClass) {
  if (!icon) {
    return null;
  }

  var iconComponent = typeof icon === 'string' ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
    focusable: false,
    iconId: icon
  }) : icon;
  return locationClass ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _utils.classnames)(dataViewClassName + "__icon", locationClass)
  }, iconComponent) : iconComponent;
}

var DataViewItem = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(DataViewItem, _Component);

  function DataViewItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getDropProps", function (_ref) {
      var id = _ref.id;
      return {
        id: id
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBeginDrag", function (_ref2) {
      var id = _ref2.id,
          type = _ref2.type,
          defaultName = _ref2.defaultName;
      return {
        id: id,
        type: type,
        defaultName: defaultName
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_canDrop", function (target, source) {
      if (target && source) {
        return target.id !== source.id;
      }

      return true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onDrop", function (target, source) {
      var onFileMove = _this.props.onFileMove;

      if (target && source) {
        var targetId = target && target.id;
        var sourceId = source && source.id;
        onFileMove && onFileMove({
          sourceId: sourceId,
          targetId: targetId
        });
      }
    });
    return _this;
  }

  var _proto = DataViewItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        dndable = _this$props.dndable,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        readable = _this$props.readable,
        writeable = _this$props.writeable,
        traverseable = _this$props.traverseable,
        traversable = _this$props.traversable,
        executable = _this$props.executable,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["dndable", "disabled", "readOnly", "readable", "writeable", "traverseable", "traversable", "executable", "className", "style"]);
    var listItemPassthroughProps = getInheritedProps(others, _list.ListItem);
    var listItemClassName = (0, _utils.classnames)(dataViewItemClassName, {
      disabled: disabled,
      readOnly: readOnly,
      traverseable: traverseable,
      traversable: traversable,
      readable: readable,
      executable: executable,
      writeable: writeable
    });
    var listItemProps = (0, _extends2["default"])({}, sanitize(others, DataViewItem), listItemPassthroughProps, {
      className: listItemClassName + " " + className,
      style: style
    });

    if (dndable) {
      var DnDLisItem = (0, _itemdnd["default"])(_list.ListItem, {
        dropItemType: 'DATAVIEW',
        dragItemType: 'DATAVIEW',
        simpleHoverStates: false
      });
      return /*#__PURE__*/_react["default"].createElement(DnDLisItem, (0, _extends2["default"])({
        getDropProps: this._getDropProps,
        onBeginDrag: this._onBeginDrag,
        canDrop: this._canDrop,
        onDrop: this._onDrop
      }, listItemProps), this.props.children);
    }

    return /*#__PURE__*/_react["default"].createElement(_list.ListItem, (0, _extends2["default"])({
      "data-tid": "ba-common-dataview-item"
    }, listItemProps), this.props.children);
  };

  return DataViewItem;
}(_react.Component);

exports["default"] = DataViewItem;
(0, _defineProperty2["default"])(DataViewItem, "propTypes", (0, _extends2["default"])({}, _list.ListItem.propTypes, {
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  dndable: _propTypes["default"].bool,
  traverseable: BaPropTypes.deprecated('It will be removed in Sprint 39.1, use "traversable" instead'),
  traversable: _propTypes["default"].bool,
  readable: _propTypes["default"].bool,
  executable: _propTypes["default"].bool,
  writeable: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onFileMove: _propTypes["default"].func
}));
(0, _defineProperty2["default"])(DataViewItem, "defaultProps", {
  traversable: false,
  readOnly: false,
  disabled: false,
  readable: true,
  executable: true,
  writeable: true,
  className: '',
  style: {},
  onFileMove: function onFileMove() {}
});
(0, _defineProperty2["default"])(DataViewItem, "Col", function (_ref3) {
  var icon = _ref3.icon,
      cols = _ref3.cols,
      content = _ref3.content;
  return /*#__PURE__*/_react["default"].createElement(_container["default"], {
    className: (0, _utils.classnames)(dataViewItemClassName + "-container", 'col')
  }, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], null, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
    className: dataViewItemClassName + "__icon "
  }, createIcon(icon)), cols.map(function (col, index) {
    return /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      key: index,
      grow: 1,
      className: dataViewItemClassName + "__item "
    }, /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
      value: content[col]
    }));
  })));
});
(0, _defineProperty2["default"])(DataViewItem, "Col2", function (_ref4) {
  var children = _ref4.children,
      others = (0, _objectWithoutPropertiesLoose2["default"])(_ref4, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], (0, _extends2["default"])({
    className: (0, _utils.classnames)(dataViewItemClassName + "-container", 'col')
  }, others), children);
});
(0, _defineProperty2["default"])(DataViewItem, "Cell", function (_ref5) {
  var children = _ref5.children,
      grow = _ref5.grow,
      others = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, ["children", "grow"]);
  return /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, (0, _extends2["default"])({
    grow: grow || 1,
    className: (0, _utils.classnames)(dataViewItemClassName + "-container", 'cell')
  }, others), children);
});
(0, _defineProperty2["default"])(DataViewItem, "Tile", function (props) {
  return /*#__PURE__*/_react["default"].createElement(_tile["default"], props);
});
(0, _defineProperty2["default"])(DataViewItem, "Label", function (_ref6) {
  var icon = _ref6.icon,
      title = _ref6.title,
      subTitle = _ref6.subTitle,
      subTitleSecondary = _ref6.subTitleSecondary;
  return /*#__PURE__*/_react["default"].createElement(_container["default"], {
    className: (0, _utils.classnames)(dataViewItemClassName + "-container", 'label')
  }, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], null, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
    className: (0, _utils.classnames)(dataViewItemClassName + "__icon")
  }, createIcon(icon)), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
    grow: 1,
    className: dataViewItemClassName + "__content "
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: dataViewItemClassName + "__title"
  }, title), /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
    direction: "row",
    justifyContent: "space-between",
    className: dataViewItemClassName + "__content "
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: dataViewItemClassName + "__subTitle"
  }, subTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: dataViewItemClassName + "__subTitle"
  }, subTitleSecondary)))));
});
(0, _defineProperty2["default"])(DataViewItem, "Input", function (_ref7) {
  var icon = _ref7.icon,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref7, ["icon"]);
  return /*#__PURE__*/_react["default"].createElement(_container["default"], {
    className: (0, _utils.classnames)(dataViewItemClassName + "-container", 'label')
  }, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], null, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
    className: (0, _utils.classnames)(dataViewItemClassName + "__icon")
  }, createIcon(icon)), /*#__PURE__*/_react["default"].createElement(_InputView["default"], props)));
});

var ContextDataViewItem = _context.withContext.apply(void 0, Object.keys(DataViewItem.propTypes))(DataViewItem);

exports.ContextDataViewItem = ContextDataViewItem;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__19__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__24__;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__27__;

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__29__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__31__;

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(350);


/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Navigator = _interopRequireDefault(__webpack_require__(351));

exports["default"] = _Navigator["default"];
exports.Navigator = _Navigator["default"];

var _DataView = _interopRequireDefault(__webpack_require__(109));

exports.DataView = _DataView["default"];

var _DataViewItem = _interopRequireWildcard(__webpack_require__(111));

exports.DataViewItem = _DataViewItem["default"];
exports.ContextDataViewItem = _DataViewItem.ContextDataViewItem;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _breadcrumb = _interopRequireDefault(__webpack_require__(71));

var _toolbar = _interopRequireDefault(__webpack_require__(31));

var _button = _interopRequireDefault(__webpack_require__(15));

var _link = _interopRequireDefault(__webpack_require__(29));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _utils = __webpack_require__(4);

var _filter_ = _interopRequireDefault(__webpack_require__(352));

var _filterApplied_ = _interopRequireDefault(__webpack_require__(353));

var _add_ = _interopRequireDefault(__webpack_require__(72));

var _overflowMenuHorizontal_ = _interopRequireDefault(__webpack_require__(41));

var _arrowsVertical_ = _interopRequireDefault(__webpack_require__(65));

var _search_ = _interopRequireDefault(__webpack_require__(354));

var _settingsAdjust_ = _interopRequireDefault(__webpack_require__(73));

var _StringResource = _interopRequireDefault(__webpack_require__(108));

var _DataView = _interopRequireDefault(__webpack_require__(109));

var _DataViewItem = _interopRequireDefault(__webpack_require__(111));

var _errorboundary = _interopRequireDefault(__webpack_require__(360));

var _Navigator = _interopRequireDefault(__webpack_require__(361));

var _class, _temp, _dec, _class2, _class3, _temp2;

function getString(value) {
  return _StringResource["default"].get(value);
}

var navigatorClassName = _Navigator["default"].navigatorClassName.replace(/"/g, '');

var DATAVIEW_HEADER_HEIGHT = 48;
var sanitize = _utils.propsUtils.sanitize,
    BaPropTypes = _utils.propsUtils.BaPropTypes;

function getToolbarButton(icon, props) {
  return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
    hasIconOnly: true,
    kind: "ghost",
    size: "small",
    renderIcon: function renderIcon(iconProps) {
      return /*#__PURE__*/_react["default"].createElement(_svgicon["default"], (0, _extends2["default"])({
        icon: icon
      }, iconProps));
    }
  }, props));
}

_toolbar["default"].Add = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Add, _Component);

  function Add() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Add.prototype;

  _proto.render = function render() {
    return getToolbarButton(_add_["default"], this.props);
  };

  return Add;
}(_react.Component);

_toolbar["default"].Filter = (_temp = _class = /*#__PURE__*/function (_Component2) {
  (0, _inheritsLoose2["default"])(Filter, _Component2);

  function Filter() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = Filter.prototype;

  _proto2.render = function render() {
    var _this$props = this.props,
        isFilterDirty = _this$props.isFilterDirty,
        otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["isFilterDirty"]);
    var icon = isFilterDirty ? _filterApplied_["default"] : _filter_["default"];
    return getToolbarButton(icon, otherProps);
  };

  return Filter;
}(_react.Component), (0, _defineProperty2["default"])(_class, "propTypes", {
  isFilterDirty: _propTypes["default"].bool
}), _temp);

_toolbar["default"].Sort = /*#__PURE__*/function (_Component3) {
  (0, _inheritsLoose2["default"])(Sort, _Component3);

  function Sort() {
    return _Component3.apply(this, arguments) || this;
  }

  var _proto3 = Sort.prototype;

  _proto3.render = function render() {
    return getToolbarButton(_arrowsVertical_["default"], this.props);
  };

  return Sort;
}(_react.Component);

_toolbar["default"].Configure = /*#__PURE__*/function (_Component4) {
  (0, _inheritsLoose2["default"])(Configure, _Component4);

  function Configure() {
    return _Component4.apply(this, arguments) || this;
  }

  var _proto4 = Configure.prototype;

  _proto4.render = function render() {
    return getToolbarButton(_settingsAdjust_["default"], this.props);
  };

  return Configure;
}(_react.Component);

_toolbar["default"].Search = /*#__PURE__*/function (_Component5) {
  (0, _inheritsLoose2["default"])(Search, _Component5);

  function Search() {
    return _Component5.apply(this, arguments) || this;
  }

  var _proto5 = Search.prototype;

  _proto5.render = function render() {
    return getToolbarButton(_search_["default"], this.props);
  };

  return Search;
}(_react.Component);

_toolbar["default"].Menu = /*#__PURE__*/function (_Component6) {
  (0, _inheritsLoose2["default"])(Menu, _Component6);

  function Menu() {
    return _Component6.apply(this, arguments) || this;
  }

  var _proto6 = Menu.prototype;

  _proto6.render = function render() {
    return getToolbarButton(_overflowMenuHorizontal_["default"], this.props);
  };

  return Menu;
}(_react.Component);

_toolbar["default"].ToolbarLink = /*#__PURE__*/function (_Component7) {
  (0, _inheritsLoose2["default"])(ToolbarLink, _Component7);

  function ToolbarLink() {
    return _Component7.apply(this, arguments) || this;
  }

  var _proto7 = ToolbarLink.prototype;

  _proto7.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_link["default"], this.props);
  };

  return ToolbarLink;
}(_react.Component);

var Navigator = (_dec = (0, _errorboundary["default"])(), _dec(_class2 = (_temp2 = _class3 = /*#__PURE__*/function (_Component8) {
  (0, _inheritsLoose2["default"])(Navigator, _Component8);

  function Navigator() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component8.call.apply(_Component8, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      folder: '',
      height: '100%',
      width: '100%',
      filter: false,
      checked: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_revertSelection", function () {
      _this.props.onSelectionChange({});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderToolbar", function () {
      return _this.props.toolbarRenderer && _this.props.toolbarRenderer(_toolbar["default"]);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderBreadcrumb", function () {
      var _this$props2 = _this.props,
          hideBackButton = _this$props2.hideBackButton,
          ancestors = _this$props2.ancestors,
          textDir = _this$props2.textDir;

      if (!ancestors) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_breadcrumb["default"], {
        size: "small",
        noTrailingSlash: true,
        "data-tid": "ba-common-navigator__breadcrumb",
        hideBackButton: hideBackButton,
        textDir: textDir,
        ancestors: ancestors,
        historyCallback: _this._onNavBack,
        navCallback: _this._nav
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderHeader", function () {
      var showBreadCrumb = _this.props.showBreadCrumb;

      if (!_this._renderBreadcrumb() && !_this._renderToolbar()) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: navigatorClassName + "__header-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: navigatorClassName + "__header"
      }, showBreadCrumb && _this._renderBreadcrumb(), _this._renderToolbar()));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_itemsRenderer", function (items, ref) {
      var _this$props3 = _this.props,
          onSaveNewFile = _this$props3.onSaveNewFile,
          dismissCreateFile = _this$props3.dismissCreateFile,
          action = _this$props3.action,
          files = _this$props3.files,
          newItemPlaceholder = _this$props3.newItemPlaceholder;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: ref
      }, action && action.type === 'CREATE' && /*#__PURE__*/_react["default"].createElement(_DataViewItem["default"], {
        length: files.length + 1,
        index: -1
      }, /*#__PURE__*/_react["default"].createElement(_DataViewItem["default"].Input, {
        icon: action.icon,
        value: getString('defaultFolder'),
        onSaveNewFile: onSaveNewFile,
        dismissCreateFile: dismissCreateFile,
        fileType: action.value,
        placeholder: newItemPlaceholder
      })), items);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderDataView", function () {
      var _this$props4 = _this.props,
          tileView = _this$props4.tileView,
          loaded = _this$props4.loaded,
          grouped = _this$props4.grouped,
          scrollToHideDataViewHeader = _this$props4.scrollToHideDataViewHeader,
          toSelectionMap = _this$props4.toSelectionMap,
          files = _this$props4.files,
          itemMenuContent = _this$props4.itemMenuContent,
          selectedItems = _this$props4.selectedItems,
          emptyState = _this$props4.emptyState,
          dataViewExtraOptions = _this$props4.dataViewExtraOptions,
          selectionMode = _this$props4.selectionMode,
          getMoreData = _this$props4.getMoreData,
          onSelectionChange = _this$props4.onSelectionChange,
          onActiveChange = _this$props4.onActiveChange,
          onItemMenu = _this$props4.onItemMenu,
          onMenuClick = _this$props4.onMenuClick,
          groupBy = _this$props4.groupBy,
          dataViewRenderer = _this$props4.dataViewRenderer,
          getId = _this$props4.getId;
      return /*#__PURE__*/_react["default"].createElement(_DataView["default"], (0, _extends2["default"])({}, dataViewExtraOptions, {
        // bool
        tileView: tileView,
        loaded: loaded,
        grouped: grouped,
        groupBy: groupBy,
        toSelectionMap: toSelectionMap // array
        ,
        data: files,
        itemMenuContent: itemMenuContent // obj
        ,
        selectedItems: selectedItems,
        emptyState: emptyState // string
        ,
        selectionMode: selectionMode // cb
        ,
        getMoreData: getMoreData,
        onSelectionChange: onSelectionChange,
        onActiveChange: onActiveChange,
        onItemMenu: onItemMenu,
        onMenuClick: onMenuClick,
        dataViewRenderer: dataViewRenderer,
        itemsRenderer: _this._itemsRenderer,
        onWheel: scrollToHideDataViewHeader ? _this._onWheel : undefined,
        scrollToHideDataViewHeader: scrollToHideDataViewHeader,
        getId: getId
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onDownWards", function (e) {
      var scrollTop = e.currentTarget.scrollTop;
      var style = _this._dataviewHeader.style;
      style.marginTop = -Math.min(scrollTop, DATAVIEW_HEADER_HEIGHT) + "px";
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onUpWards", function () {
      var style = _this._dataviewHeader.style;
      style.marginTop = '0px';
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onWheel", function (e) {
      if (e.deltaY > 0) {
        _this._onDownWards(e);
      } else {
        _this._onUpWards();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onNavBack", function () {
      var onNavBack = _this.props.onNavBack;
      onNavBack();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_nav", function (index) {
      var onNav = _this.props.onNav;
      onNav(index);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_dataviewHeaderRef", function (ref) {
      _this._dataviewHeader = ref;
    });
    return _this;
  }

  var _proto8 = Navigator.prototype;

  _proto8.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var ancestors = this.props.ancestors;
    if (!ancestors || !newProps.ancestors) return;

    if (ancestors.length !== newProps.ancestors.length) {
      this._revertSelection();
    }
  };

  _proto8._renderDataViewFooter = function _renderDataViewFooter() {
    var dataViewFooterRenderer = this.props.dataViewFooterRenderer;

    if (dataViewFooterRenderer) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: navigatorClassName + "__dataview-footer"
      }, dataViewFooterRenderer());
    }

    return null;
  };

  _proto8._renderDataViewHeader = function _renderDataViewHeader() {
    var _this$props5 = this.props,
        dataViewHeaderRenderer = _this$props5.dataViewHeaderRenderer,
        scrollToHideDataViewHeader = _this$props5.scrollToHideDataViewHeader;
    var dataViewHeaderClassName = (0, _utils.classnames)(navigatorClassName + "__dataview-header", {
      scrollable: scrollToHideDataViewHeader
    });

    if (dataViewHeaderRenderer) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: dataViewHeaderClassName,
        ref: this._dataviewHeaderRef
      }, dataViewHeaderRenderer());
    }

    return null;
  };

  _proto8.render = function render() {
    var _this$props6 = this.props,
        height = _this$props6.height,
        width = _this$props6.width,
        className = _this$props6.className,
        style = _this$props6.style,
        ancestors = _this$props6.ancestors,
        toolbarRenderer = _this$props6.toolbarRenderer,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props6, ["height", "width", "className", "style", "ancestors", "toolbarRenderer"]);
    var styles = (0, _extends2["default"])({
      width: width,
      height: height
    }, style);
    var mainClassName = (0, _utils.classnames)(navigatorClassName + "__main", {
      noHeader: (!ancestors || ancestors.length === 0) && !toolbarRenderer
    });
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, Navigator), {
      className: navigatorClassName + " " + className,
      style: styles
    }), this._renderHeader(), /*#__PURE__*/_react["default"].createElement("div", {
      className: mainClassName
    }, this._renderDataViewHeader(), this._renderDataView(), this._renderDataViewFooter()));
  };

  return Navigator;
}(_react.Component), (0, _defineProperty2["default"])(_class3, "propTypes", {
  /** Array of files displayed in the navigator list */
  files: _propTypes["default"].array.isRequired,

  /** The items in the navigator menu that are selected */
  selectedItems: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].number]).isRequired,

  /** Width of the navigator */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Height of the navigator */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Controls the spinner gif visibility */
  loaded: _propTypes["default"].bool,

  /** Controls the visibility of the back button */
  hideBackButton: _propTypes["default"].bool,

  /** Allows for grouping of list items */
  grouped: _propTypes["default"].bool,

  /** Hides data view header on scroll */
  scrollToHideDataViewHeader: _propTypes["default"].bool,

  /** Displays items in a tile view */
  tileView: _propTypes["default"].bool,

  /** Ancestors of current data view */
  ancestors: _propTypes["default"].array,

  /** List of items in the context menu */
  itemMenuContent: _propTypes["default"].array,

  /** Child element inside the navigator */
  children: _propTypes["default"].element,

  /** Extra functionality for file interaction */
  action: _propTypes["default"].object,

  /** Specifies what is displayed when there is no content */
  emptyState: _propTypes["default"].shape({
    icon: _propTypes["default"].object,
    label: _propTypes["default"].string
  }),

  /** Callback for navigating through breadcrumb */
  onNav: _propTypes["default"].func,

  /** Callback for navigating back through breadcrumb */
  onNavBack: _propTypes["default"].func,

  /** Loads more data for infinite scroll */
  getMoreData: _propTypes["default"].func,

  /** Handler for adding a folder */
  onAddFolder: _propTypes["default"].func,

  /** Handler for creating a new file */
  onSaveNewFile: _propTypes["default"].func,

  /** Handler for changing item selection */
  onSelectionChange: _propTypes["default"].func,

  /** Handler when esc key is pressed during new file creation */
  dismissCreateFile: _propTypes["default"].func,

  /** Callback for clicking a context menu item */
  onItemMenu: _propTypes["default"].func,

  /** Renders the data view */
  dataViewRenderer: _propTypes["default"].func.isRequired,

  /** Renders the header */
  dataViewHeaderRenderer: _propTypes["default"].func,

  /** Renders the footer */
  dataViewFooterRenderer: _propTypes["default"].func,

  /** Renders the toolbar */
  toolbarRenderer: _propTypes["default"].func,

  /** Handler for changing active item */
  onActiveChange: _propTypes["default"].func,

  /** Callback for clicking ... on a list item to open a context menu  */
  onMenuClick: _propTypes["default"].func,

  /** Specifies how to group items */
  groupBy: _propTypes["default"].func,

  /** Allow selection to be based on id rather than index */
  getId: _propTypes["default"].func,

  /** Specifies how many items can be selected at a time */
  selectionMode: _propTypes["default"].oneOf(['none', 'disabled', 'single', 'multi']),

  /** Custom class name */
  className: _propTypes["default"].string,

  /** Custom styles */
  style: _propTypes["default"].object,

  /** Size of the breadcrumb */
  breadcrumbSize: _breadcrumb["default"].propTypes.size,

  /** Extra data view options */
  dataViewExtraOptions: _propTypes["default"].object,

  /** Flag to make selected items an object */
  toSelectionMap: _propTypes["default"].bool,

  /** Direction of text */
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),

  /** Place holder text for new items input box */
  newItemPlaceholder: _propTypes["default"].string,

  /** Show/hide breadcrumb in header*/
  showBreadCrumb: _propTypes["default"].bool
}), (0, _defineProperty2["default"])(_class3, "defaultProps", {
  height: '100%',
  breadcrumbSize: 'small',
  onNav: function onNav() {},
  onNavBack: function onNavBack() {},
  className: '',
  styles: {},
  dataViewExtraOptions: {},
  showBreadCrumb: true
}), _temp2)) || _class2);
exports["default"] = Navigator;

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/filter_16");

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/filter-applied_16");

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/search_16");

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

var amdi18n={"__root":{"defaultFolder":"Default Folder","placeholder":"Untitled Folder"},"__cs":{"defaultFolder":"Výchozí složka","placeholder":"Složka bez názvu"},"__da":{"defaultFolder":"Standardfolder","placeholder":"Folder uden navn"},"__de":{"defaultFolder":"Standardordner","placeholder":"Nicht benannter Ordner"},"__es":{"defaultFolder":"Carpeta predeterminada","placeholder":"Carpeta sin título"},"__fi":{"defaultFolder":"Oletuskansio","placeholder":"Nimetön kansio"},"__fr":{"defaultFolder":"Dossier par défaut","placeholder":"Dossier sans titre"},"__hr":{"defaultFolder":"Defaultni folder","placeholder":"Neimenovani folder"},"__hu":{"defaultFolder":"Alapértelmezett mappa","placeholder":"Névtelen mappa"},"__it":{"defaultFolder":"Cartella predefinita","placeholder":"Cartella senza titolo "},"__ja":{"defaultFolder":"デフォルトのフォルダー","placeholder":"無題フォルダー"},"__kk":{"defaultFolder":"Әдепкі қалта","placeholder":"Аты жоқ қалта"},"__ko":{"defaultFolder":"기본 폴더","placeholder":"제목 없는 폴더"},"__nb":{"defaultFolder":"Standardmappe","placeholder":"Mappe uten tittel"},"__nl":{"defaultFolder":"Standaardmap","placeholder":"Naamloze map"},"__no":{"defaultFolder":"Standardmappe","placeholder":"Mappe uten tittel"},"__pl":{"defaultFolder":"Folder domyślny","placeholder":"Folder bez tytułu"},"__pt":{"defaultFolder":"Pasta padrão","placeholder":"Pasta sem título"},"__pt-br":{"defaultFolder":"Pasta padrão","placeholder":"Pasta sem título"},"__ro":{"defaultFolder":"Folder implicit","placeholder":"Folder fără titlu "},"__ru":{"defaultFolder":"Папка по умолчанию","placeholder":"Папка без имени"},"__sl":{"defaultFolder":"Privzeta mapa","placeholder":"Mapa brez naslova"},"__sv":{"defaultFolder":"Standardmapp","placeholder":"Namnlös mapp "},"__th":{"defaultFolder":"โฟลเดอร์ดีฟอลต์","placeholder":"โฟลเดอร์ที่ไม่มีชื่อ"},"__tr":{"defaultFolder":"Varsayılan Klasör","placeholder":"Adsız Klasör"},"__zh":{"defaultFolder":"缺省文件夹","placeholder":"未命名文件夹"},"__zh-cn":{"defaultFolder":"缺省文件夹","placeholder":"未命名文件夹"},"__zh-hk":{"defaultFolder":"預設資料夾","placeholder":"未命名的資料夾"},"__zh-mo":{"defaultFolder":"預設資料夾","placeholder":"未命名的資料夾"},"__zh-sg":{"defaultFolder":"缺省文件夹","placeholder":"未命名文件夹"},"__zh-tw":{"defaultFolder":"預設資料夾","placeholder":"未命名的資料夾"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-dataview{width:100%;height:100%;position:relative}.ba-common-dataview__empty-state{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.ba-common-dataview__empty-state-container{display:flex;flex-direction:column;align-items:center}.ba-common-dataview__empty-state-icon{display:flex;justify-content:center;align-items:center;margin-bottom:0.5em;opacity:0.5}.ba-common-dataview__loading{height:100%;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;align-items:center}.ba-common-dataview__groupedLabel{margin-top:1rem}.ba-common-dataview__groupedLabel.ba-common-label{font-size:1rem}.ba-common-dataview .is-multiSelecting .ba-common-listItem .ba-common-listItem__cmBtn{visibility:hidden}.ba-common-dataview .is-tileView.ba-common-list>div{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper:nth-child(2n-1) .ba-common-dataviewItem.ba-common-listItem{margin-right:0}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper.is-groupedLabel{width:100%;pointer-events:none}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper.is-groupedLabel .ba-common-listItem:hover{background:transparent}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem{padding:0;margin-right:32px;margin-bottom:24px;border:none;max-height:100%}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem.is-selected{border:none}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem.is-traversable .ba-common-flexLayout-item.ba-common-listItem__cmBtn{position:absolute;top:0;right:8px;bottom:0;margin:auto;display:flex}.ba-common-dataview .is-tileView .ba-common-listItem-wrapper .ba-common-dataviewItem.ba-common-listItem .ba-common-flexLayout-item.ba-common-listItem__cmBtn{position:absolute;right:16px;bottom:9px}.ba-common-dataview__menuContainer.ba-theme-default.ba-common-container{transition:none;z-index:9001}.ba-common-dataview.is-rowView.ba-common-listItem{border-top-color:#c0bfc0}.ba-common-dataview.is-rowView .ba-common-dataview__item--date,.ba-common-dataview.is-rowView .ba-common-dataview__item--ellipsis,.ba-common-dataview.is-rowView .ba-common-dataview__item--quality{color:#c0bfc0}.ba-common-dataview.is-tileView .ba-common-dataview__content{border-color:#eaeaea}.ba-common-dataview.is-tileView .ba-common-dataview__content:hover{border-color:#c0bfc0}.ba-common-dataview.is-tileView .ba-common-dataview__description__type{color:#949394}.ba-common-dataview.is-tileView .ba-common-dataview__description__name{color:#343334}.ba-common-dataview.is-tileView .ba-common-dataview__description__footer{color:#949394}\n", ""]);

// exports
exports.locals = {
	"dataView": "\"ba-common-dataview\""
};

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _textinput = _interopRequireDefault(__webpack_require__(47));

var _StringResource = _interopRequireDefault(__webpack_require__(108));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function getString(value) {
  return _StringResource["default"].get(value);
}

var InputView = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(InputView, _Component);

  function InputView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      value: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._node = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function () {
      _this.props.onSaveNewFile(_this._node.props.value, _this.props.fileType);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_saveFIle", function () {
      _this.props.onSaveNewFile(_this._node.props.value, _this.props.fileType);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (event) {
      // enter
      switch (event.keyCode) {
        // enter
        case 13:
          {
            _this._saveFIle();

            break;
          }
        // esc

        case 27:
          {
            _this.props.dismissCreateFile();

            break;
          }

        default:
      }
    });
    return _this;
  }

  var _proto = InputView.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      _this2._node._input.inputNode.focus();
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        getLocaleString = _this$props.getLocaleString,
        placeholder = _this$props.placeholder;
    return /*#__PURE__*/_react["default"].createElement(_textinput["default"], {
      ref: this._ref,
      onKeyDown: this._onKeyDown,
      onBlur: this._onBlur,
      placeholder: placeholder || getLocaleString('placeholder') // autoFocus
      ,
      value: this.state.value,
      fullWidth: true,
      onChange: function onChange(v) {
        return _this3.setState({
          value: v
        });
      }
    });
  };

  return InputView;
}(_react.Component);

exports["default"] = InputView;
(0, _defineProperty2["default"])(InputView, "propTypes", (0, _extends2["default"])({}, _textinput["default"].propTypes, {
  onSaveNewFile: _propTypes["default"].func,
  dismissCreateFile: _propTypes["default"].func,
  fileType: _propTypes["default"].string,
  getLocaleString: _propTypes["default"].func,
  placeholder: _propTypes["default"].string
}));
(0, _defineProperty2["default"])(InputView, "defaultProps", {
  dismissCreateFile: function dismissCreateFile() {},
  getLocaleString: getString
});

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(359);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-dataviewItem__subTitle{font-size:.75rem;font-weight:400;line-height:1rem}.ba-common-dataviewItem{padding-left:16px;min-height:48px;max-height:48px;position:relative}.ba-common-dataviewItem:after{content:'';width:100%;border-bottom-width:thin;border-bottom-style:solid;position:absolute;bottom:0px;left:0}.ba-common-dataviewItem-container{width:100%}.ba-common-dataviewItem-container.is-cell{display:flex;justify-content:center;align-items:center}.ba-common-dataviewItem__icon{display:flex;justify-content:center;align-items:center;padding-right:1em}.ba-common-dataviewItem__item{font-size:1rem;line-height:1.125rem}.ba-common-dataviewItem:after{border-color:#eaeaea}.ba-common-dataviewItem.is-focus:after{border-color:transparent}.ba-common-dataviewItem__subTitle{color:#595859}\n", ""]);

// exports
exports.locals = {
	"dataViewItem": "\"ba-common-dataviewItem\""
};

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var _default = function _default(FallbackCom) {
  return function (Comp) {
    var components = /*#__PURE__*/function (_Component) {
      (0, _inheritsLoose2["default"])(components, _Component);

      function components(props) {
        var _this;

        _this = _Component.call(this, props) || this;
        _this.state = {
          hasError: false
        };
        return _this;
      }

      var _proto = components.prototype;

      _proto.componentDidCatch = function componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({
          hasError: true
        }); // You can also log the error to an error reporting service

        console.error('something wrong happened; error:', error); // eslint-disable-line

        console.info('something wrong happened; info:', info); // eslint-disable-line
      };

      _proto.render = function render() {
        if (FallbackCom && this.state.hasError) {
          return FallbackCom;
        }

        return /*#__PURE__*/_react["default"].createElement(Comp, this.props);
      };

      return components;
    }(_react.Component);

    (0, _defineProperty2["default"])(components, "propTypes", {
      children: _propTypes["default"].any
    });
    components.WrappedComponent = Comp;
    return components;
  };
};

exports["default"] = _default;

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(362);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-navigator .ba-common-dataview{flex-grow:1;flex-shrink:1;overflow:auto}.ba-navigator__header{width:100%;height:50px;display:inline-flex;justify-content:space-between;align-items:center;border-bottom-width:1px;border-bottom-style:solid}.ba-navigator__header .ba-common-toolbar{flex-wrap:nowrap !important;flex:0;-ms-flex:auto;width:100%;display:inline-flex}.ba-navigator__main{width:100%;height:calc(100% - 50px);display:flex;flex-direction:column;position:relative;overflow:hidden}.ba-navigator__main.is-noHeader{height:100%}.ba-navigator__card-container{display:flex;flex-wrap:wrap;padding-top:2rem}.ba-navigator__card-container .ba-card{width:49%;margin-right:1%;margin-top:1%}.ba-navigator__grid-container{padding-top:2rem}.ba-navigator__empty-state{height:100%;display:flex;justify-content:center;align-items:center}.ba-navigator__empty-state-icon{display:flex;justify-content:center;align-items:center;margin-bottom:0.5em}.ba-navigator__dataview-header{height:48px}.ba-navigator__dataview-footer{height:auto}.ba-navigator{background-color:#fff}.ba-navigator__header{border-bottom-color:#e0e0e0}.ba-navigator__dataview-header.is-scrollable{transition:margin .2s ease-in-out}\n", ""]);

// exports
exports.locals = {
	"navigatorClassName": "\"ba-navigator\""
};

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__38__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__40__;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32");

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__46__;

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__47__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/arrows--vertical_32");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__71__;

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/add_32");

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/settings--adjust_32");

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__74__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[349,0]]]);
});